import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { DataGridProvider } from "@vega-core/components/DataGrid/DataGridProvider";
import { OutdatedBrowserModal } from "@vega-core/components/OutdatedBrowserModal/OutdatedBrowserModal";
import { ToastContainer } from "@vega-core/components/Toast/Toast";
import { useDynamicManifest } from "@vega-core/hooks/useDynamicManifest";
import { CoInvestmentFullPaths } from "@vega-modules/paths";
import { CoInvestNotificationsStreamRunner } from "@vega-modules/scenes/CoInvestments/components/CoInvestNotificationsStreamRunner/CoInvestNotificationsStreamRunner";
import { ProvidersWrapper } from "@vega-modules/scenes/Root/ProvidersWrapper";

import { GpCoInvestLayoutContextProvider } from "./layout/GpCoInvestLayoutContextProvider";
import { PermissionsRouteGuard } from "./scenes/Root/PermissionsRouteGuard";
import { Root } from "./scenes/Root/Root";
import { gpCoInvestRouteObjects } from "./scenes/Root/Routes";

import "inter-ui/inter-variable.css";
import "inter-ui/inter.css";
import "@vega-assets/css/index.css";

export function App() {
  useDynamicManifest();

  return (
    <DataGridProvider>
      <ProvidersWrapper
        outletWrapper={(outlet) => (
          <>
            <PermissionsRouteGuard
              fallbackPath={CoInvestmentFullPaths.CoInvestments}
            >
              <GpCoInvestLayoutContextProvider>
                <Root>{outlet}</Root>
                <CoInvestNotificationsStreamRunner />
                <div id="sidebar-modal-root" />
                <ToastContainer />
                <OutdatedBrowserModal />
              </GpCoInvestLayoutContextProvider>
            </PermissionsRouteGuard>
            <ReactQueryDevtools
              buttonPosition="bottom-right"
              initialIsOpen={false}
            />
          </>
        )}
        routes={gpCoInvestRouteObjects}
      />
    </DataGridProvider>
  );
}
